import { Injectable } from '@angular/core';
import { CanDeactivate, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OverviewDetailsComponent } from './details.component';
import { OverviewStateService } from '../../services/state.service';
import { AssetListItem, AssetStateService } from 'app/services';

export interface OverviewDetailsRouteData {
    asset?: AssetListItem;
    tab?: string;
    err?: Error;
}

@Injectable()
export class OverviewDetailsResolver implements CanDeactivate<OverviewDetailsComponent>, Resolve<OverviewDetailsRouteData> {

    constructor(
        private assetState: AssetStateService,
        private overviewState: OverviewStateService
    ) { }

    resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<OverviewDetailsRouteData> {

        if (route.queryParams.redirecting) {
            // this is a request triggered by our reuse strategy, don't perform any actions, as we'll be redirected away shortly
            return Promise.resolve(null);
        }

        return this.assetState.getAsset(route.params.asset)
            .then(asset => {
                this.overviewState.setAsset(asset);
                return { asset: asset, tab: route.params.tab };
            })
            .catch(err => {
                return { err: err };
            });
    }

    canDeactivate(component: OverviewDetailsComponent, _currentRoute: ActivatedRouteSnapshot, _currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): boolean {
        // if we navigate to the root, we need to clear the selected asset and inform the component to do any necessary cleanup
        if (nextState.url === '/status') {
            this.overviewState.setAsset(null);
            if (component) {
                component.ngOnDeactivate();
            }
        }
        return true;
    }


}
